import {
  CV_SHOW_MENU_AVATAR,
  CV_HIDE_MENU_AVATAR,
  CV_SHOW_MENU_AVATAR_MOBILE,
  CV_HIDE_MENU_AVATAR_MOBILE,
} from '../actions/action-creator';

const initialState = {
  error: null,
  loading: false,
  showMenu: false,
  showMenuMobile: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CV_SHOW_MENU_AVATAR:
      return {
        ...state,
        error: null,
        loading: false,
        showMenu: true,
      };
    case CV_HIDE_MENU_AVATAR:
      return {
        ...state,
        error: null,
        loading: false,
        showMenu: false,
      };
    case CV_SHOW_MENU_AVATAR_MOBILE:
      return {
        ...state,
        error: null,
        loading: false,
        showMenuMobile: true,
      };
    case CV_HIDE_MENU_AVATAR_MOBILE:
      return {
        ...state,
        error: null,
        loading: false,
        showMenuMobile: false,
      };

    default:
      return state;
  }
};
